export default function GroupButtonViewToggle({ view, setView }) {
  const views = [
    {
      name: "grid",
      icon:
        view === "grid"
          ? "/assets/icons/ic_grid_active.svg"
          : "/assets/icons/ic_grid.svg",
    },
    {
      name: "list",
      icon:
        view === "list"
          ? "/assets/icons/ic_list_active.svg"
          : "/assets/icons/ic_list.svg",
    },
  ];

  return (
    <div
      className="flex gap-2 rounded-2xl px-3 py-[6px]"
      style={{ boxShadow: "0px 2px 4.8px 0px rgba(0, 0, 0, 0.10)" }}
    >
      {views.map(({ name, icon }) => (
        <IconToggle
          key={name}
          isActive={view === name}
          icon={icon}
          onClick={() => setView(name)}
        />
      ))}
    </div>
  );
}

const IconToggle = ({ isActive, icon, onClick }) => (
  <div
    style={{
      width: 32,
      height: 32,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 8,
      backgroundColor: isActive ? "#E1F7FF" : "transparent",
      transition: "all 0.3s",
    }}
    onClick={onClick}
  >
    <img src={icon} className="w-[24px] h-[24px]" />
  </div>
);
